<template>
    <v-snackbar v-model="snackbar" top right :color="notificationType" :timeout="timeout">
        <v-icon left>{{ icon }}</v-icon> {{ text }}
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            notificationType: '',
            snackbar: false,
            text: '',
            timeout: 5000,
            icon: 'mdi-check-circle-outline',
        }
    },
    created() {
        EventBus.listen('notification', (params) => {

            const {text, type, timeout} = (params || {});

            if (text) {
                this.notificationType = type || 'success';
                this.text = text;
                this.timeout = timeout || 5000;
                this.snackbar = true;
                // TODO:: Add other icons for warning and info. See the style guide https://icc-it.atlassian.net/wiki/x/AYCFrwE
                this.icon = this.notificationType === 'error' ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline';
            }

        });
    }
}
</script>
